import { createFileRoute } from "@tanstack/react-router";
import { Step0Welcome } from "@/features/vendor/onboarding/v1/step-0-welcome";

export const Route = createFileRoute("/vendors/onboarding/v1/step-0-welcome")({
  component: Step0Welcome,
});
